import React, { useEffect, useState } from "react";
import CustomCheckbox from "../../components/CustomCheckbox";
import Heading from "../../components/Heading";
import CustomDivider from "../../components/CustomDivider";

const Consent = ({
  setIsFormValid,
}: {
  setIsFormValid: (value: boolean) => void;
}) => {
  const [dataIsCorrect, setDataIsCorrect] = useState(false);
  const [dataIsTrue, setDataIsTrue] = useState(false);
  const [dataIsShared, setDataIsShared] = useState(false);
  useEffect(() => {
    if (dataIsCorrect && dataIsTrue && dataIsShared) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataIsCorrect, dataIsTrue, dataIsShared]);

  return (
    <>
      <Heading>Consent</Heading>
      <div className="mt-4">
        <CustomCheckbox
          checked={dataIsCorrect}
          onClick={() => {
            setDataIsCorrect(!dataIsCorrect);
          }}
        >
          You confirm that all the data is correct. *
        </CustomCheckbox>
        <CustomDivider />
        <CustomCheckbox
          checked={dataIsTrue}
          onClick={() => {
            setDataIsTrue(!dataIsTrue);
          }}
        >
          You confirm that provided data is true. *
        </CustomCheckbox>
        <CustomDivider />
        <CustomCheckbox
          checked={dataIsShared}
          onClick={() => {
            setDataIsShared(!dataIsShared);
          }}
        >
          My personal information is shared with MyToyota insurance to obtain
          comparative comprehensive motor insurance quotations. *
        </CustomCheckbox>
      </div>
    </>
  );
};

export default Consent;
